import React, { useState } from 'react'
import { compareAsc, format } from 'date-fns'
import moment from "moment";
import jsPDF from "jspdf";
import "jspdf-autotable";
import { useDispatch, useSelector } from 'react-redux';
function DownloadHolidayCom() {
    let SERVER_URL = process.env.REACT_APP_API_URL;
    let BASE_URL = process.env.REACT_APP_APP_URL;
    let token = JSON.parse(localStorage.getItem('key'));
    const get_oermission_data = useSelector((state) => state);
    let countryId = get_oermission_data.login_Permission.user_data.country
    const [holidaylist, setHolidaylist] = useState([]);
    const HandleDownloadHoliday = (year) => {
        const country_title = ['', 'India Holidays', 'United States of America Holidays', 'United Kingdom Holidays']
        const title = year + ' ' + country_title[countryId];
        const headers = [["S.No", "Date", "Day", "On Account Of", "Holiday Type"]];
        const footerdata = "There are three National Holidays in India, 26th January, 15th August and 2nd October and there are Major festivals like Holi and Diwali";
        var doc = new jsPDF("p", "pt");

        const response = fetch(SERVER_URL + `api/holiday/office-holiday-list-by-year-company`,
            {
                method: 'post',
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json',
                    'authorization': `bearer ${token.value}`
                },
                body: JSON.stringify({
                    countryId: countryId,
                    year: year
                }),
            })
            .then(res => res.json())
            .then(data => {
                if (data.status == true) {
                    for (var i = 0, array = []; i < data.result.length; i++) {
                        var el = data.result[i];
                        array.push([el.SERIAL_NO, el.holiday_date, moment(el.day).format('dddd'), el.holiday_name, el.holiday_type == 1 ? 'Restricted Holiday' : el.holiday_type == 2 ? 'Gazetted Holiday' : el.holiday_type == 2 ? 'National Holiday' : '']);
                    }
                    downloadReports(array)
                }
            });



        const downloadReports = (rea_arr) => {
            let content = {
                startY: 170,
                head: headers,
                body: rea_arr,
            };

            doc.setFontSize(24)
            doc.setTextColor('#2d2c2e');
            doc.text(title, 180, 150,);
            doc.autoTable(content);
            const fileName = countryId == 1 ? 'IN' : countryId == 2 ? 'USA' : countryId == 3 ? 'UK' : ''

            doc.addImage("assets/images/qbs_learning.png", "JPEG", 40, 50, 80, 80);


            doc.text('Note', 42, doc.lastAutoTable.finalY + 30, { align: 'left' })
            doc.setFontSize(12)
            doc.setTextColor('black');
            let finalY = doc.lastAutoTable.finalY;

            doc.text("There are three National Holidays in India, 26th January, 15th August and 2nd October and", 42, doc.lastAutoTable.finalY + 48, { align: 'left' })
            doc.text("there are Major festivals like Holi and Diwali.", 40, doc.lastAutoTable.finalY + 62, { align: 'left' })
            doc.save('Holidays_' + year + '_' + fileName + ".pdf")
        }

    }
    return (
        <div>

            <div className='float-end mb10 holidaybtn_wrp'>
                {/* <button onClick={e => HandleDownloadHoliday(moment().format('YYYY') - 1)} className="btn_5 mr08"><i className='icon icon-download mr08'></i>2023</button> */}
                <button onClick={e => HandleDownloadHoliday(moment().format('YYYY')-1)} className="btn_5 mr08"><i className='icon icon-download mr08'></i>2025</button>
                <button onClick={e => HandleDownloadHoliday(moment().format('YYYY'))} className="btn_5"><i className='icon icon-download mr08'></i>2026</button>
            </div>
        </div>
    )
}

export default DownloadHolidayCom
